import { createSelector, createSlice } from '@reduxjs/toolkit';

const mapSlice = createSlice({
    initialState: {
        shifts: null,
        shiftContext: null,
        isLoadingShifts: false,
        isLoadingContext: false,
        selectedShiftId: null,
        filters: {
            province: '',
            skill: '',
            showFilled: true,
        },
    },
    name: 'map',
    reducers: {
        fetchMapShifts: state => {
            state.isLoadingShifts = true;
        },
        mapShiftsFetched: (state, { payload }) => {
            state.shifts = payload;
            state.isLoadingShifts = false;
        },
        mapShiftsFetchFailed: state => {
            state.isLoadingShifts = false;
        },
        fetchShiftContext: (state, { payload }) => {
            state.isLoadingContext = true;
            state.selectedShiftId = payload.shiftId;
            state.shiftContext = null;
        },
        shiftContextFetched: (state, { payload }) => {
            state.shiftContext = payload;
            state.isLoadingContext = false;
        },
        shiftContextFetchFailed: state => {
            state.isLoadingContext = false;
        },
        clearShiftContext: state => {
            state.shiftContext = null;
            state.selectedShiftId = null;
        },
        setMapFilters: (state, { payload }) => {
            state.filters = { ...state.filters, ...payload };
        },
    },
});

const getSelf = state => state.map;

export const getMapShifts = createSelector(getSelf, state => state.shifts);
export const getShiftContext = createSelector(
    getSelf,
    state => state.shiftContext,
);
export const getSelectedShiftId = createSelector(
    getSelf,
    state => state.selectedShiftId,
);
export const getMapFilters = createSelector(getSelf, state => state.filters);
export const isLoadingShifts = createSelector(
    getSelf,
    state => state.isLoadingShifts,
);
export const isLoadingContext = createSelector(
    getSelf,
    state => state.isLoadingContext,
);

export const {
    fetchMapShifts,
    mapShiftsFetched,
    mapShiftsFetchFailed,
    fetchShiftContext,
    shiftContextFetched,
    shiftContextFetchFailed,
    clearShiftContext,
    setMapFilters,
} = mapSlice.actions;

export default mapSlice.reducer;
